module.exports = __webpack_public_path__ + "post-listing-block-5-image-3-5KCJR.jpg";